<template>
  <div class="mobile-account">
    <header>
      <TopBar />
    </header>
  </div>
</template>
<script setup>
import TopBar from "../widgets/topbar.vue";
</script>
